// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

*::-webkit-scrollbar {
  height: 0;
  width: 4px;
}
*::-webkit-scrollbar-track {
  border-radius: 8px;
}
*::-webkit-scrollbar-thumb {
  height: 7px;
  border-radius: 30px;

  background-color: #FF7E10;
}


*::-webkit-slider-thumb {
  /* ... */
  height: 6px;
}
*:hover::-webkit-scrollbar {
  height: 6px;

  background: #fff;
  /**/
}

.popup-overlay {
  background: rgba(0, 0, 0, 0.30);
}

/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.bottom-\\[120px\\]{
  bottom: 120px;
}
.bottom-\\[40\\%\\]{
  bottom: 40%;
}
.left-\\[-52px\\]{
  left: -52px;
}
.left-\\[10\\%\\]{
  left: 10%;
}
.left-\\[30px\\]{
  left: 30px;
}
.right-0{
  right: 0px;
}
.top-\\[-0\\.45rem\\]{
  top: -0.45rem;
}
.top-\\[-8\\.1rem\\]{
  top: -8.1rem;
}
.top-\\[-8\\.4rem\\]{
  top: -8.4rem;
}
.top-\\[25\\%\\]{
  top: 25%;
}
.top-\\[55\\%\\]{
  top: 55%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.mx-\\[0\\.375rem\\]{
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.flex{
  display: flex;
}
.hidden{
  display: none;
}
.h-\\[1\\.5rem\\]{
  height: 1.5rem;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[2\\.5rem\\]{
  height: 2.5rem;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[6rem\\]{
  height: 6rem;
}
.h-\\[7\\.75rem\\]{
  height: 7.75rem;
}
.h-\\[9\\.5rem\\]{
  height: 9.5rem;
}
.h-\\[9rem\\]{
  height: 9rem;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.w-\\[0\\.74px\\]{
  width: 0.74px;
}
.w-\\[2\\.5rem\\]{
  width: 2.5rem;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.max-w-\\[573px\\]{
  max-width: 573px;
}
.flex-1{
  flex: 1 1;
}
.shrink-0{
  flex-shrink: 0;
}
.cursor-pointer{
  cursor: pointer;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-\\[0\\.4rem\\]{
  gap: 0.4rem;
}
.gap-\\[0\\.5rem\\]{
  gap: 0.5rem;
}
.gap-\\[1rem\\]{
  gap: 1rem;
}
.gap-\\[2\\.5rem\\]{
  gap: 2.5rem;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.rounded-\\[0\\.5rem\\]{
  border-radius: 0.5rem;
}
.rounded-\\[0\\.625rem\\]{
  border-radius: 0.625rem;
}
.rounded-\\[0\\.6rem\\]{
  border-radius: 0.6rem;
}
.rounded-\\[100px\\]{
  border-radius: 100px;
}
.rounded-\\[2\\.3rem\\]{
  border-radius: 2.3rem;
}
.rounded-\\[3\\.125rem\\]{
  border-radius: 3.125rem;
}
.rounded-\\[6\\.25rem\\]{
  border-radius: 6.25rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-r-\\[3\\.125rem\\]{
  border-top-right-radius: 3.125rem;
  border-bottom-right-radius: 3.125rem;
}
.bg-\\[\\#CDCDCD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(205 205 205 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF7E10\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 126 16 / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.p-\\[0\\.375rem\\]{
  padding: 0.375rem;
}
.p-\\[0\\.5rem\\]{
  padding: 0.5rem;
}
.p-\\[0\\.75rem\\]{
  padding: 0.75rem;
}
.p-\\[1rem\\]{
  padding: 1rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0\\.74rem\\]{
  padding-left: 0.74rem;
  padding-right: 0.74rem;
}
.px-\\[1\\.5rem\\]{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[1rem\\]{
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-\\[0\\.37rem\\]{
  padding-top: 0.37rem;
  padding-bottom: 0.37rem;
}
.py-\\[0\\.4rem\\]{
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.py-\\[0\\.5rem\\]{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-\\[0\\.75rem\\]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-\\[1\\.5rem\\]{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[2\\.5rem\\]{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.pl-\\[1\\.5rem\\]{
  padding-left: 1.5rem;
}
.pr-\\[1rem\\]{
  padding-right: 1rem;
}
.pt-\\[1\\.5rem\\]{
  padding-top: 1.5rem;
}
.text-center{
  text-align: center;
}
.font-manrope{
  font-family: Manrope, sans-serif;
}
.font-raleway{
  font-family: Raleway, sans-serif;
}
.text-\\[0\\.45rem\\]{
  font-size: 0.45rem;
}
.text-\\[0\\.50rem\\]{
  font-size: 0.50rem;
}
.text-\\[0\\.65rem\\]{
  font-size: 0.65rem;
}
.text-\\[0\\.875rem\\]{
  font-size: 0.875rem;
}
.text-\\[1\\.5rem\\]{
  font-size: 1.5rem;
}
.text-\\[1rem\\]{
  font-size: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-normal{
  font-weight: 400;
}
.tracking-\\[0\\.14px\\]{
  letter-spacing: 0.14px;
}
.text-\\[\\#000000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#565656\\]{
  --tw-text-opacity: 1;
  color: rgb(86 86 86 / var(--tw-text-opacity));
}
.text-\\[\\#FF7E10\\]{
  --tw-text-opacity: 1;
  color: rgb(255 126 16 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
.placeholder\\:font-normal::placeholder{
  font-weight: 400;
}
.placeholder\\:text-\\[\\#565656\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(86 86 86 / var(--tw-text-opacity));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 430px){
  .xsm\\:top-\\[45\\%\\]{
    top: 45%;
  }
  .xsm\\:h-\\[10rem\\]{
    height: 10rem;
  }
  .xsm\\:h-\\[27px\\]{
    height: 27px;
  }
  .xsm\\:h-\\[6rem\\]{
    height: 6rem;
  }
  .xsm\\:text-\\[0\\.65rem\\]{
    font-size: 0.65rem;
  }
  .xsm\\:text-\\[0\\.875rem\\]{
    font-size: 0.875rem;
  }
  .xsm\\:text-\\[1rem\\]{
    font-size: 1rem;
  }
}
@media (min-width: 576px){
  .sm\\:top-\\[-10\\.5rem\\]{
    top: -10.5rem;
  }
  .sm\\:top-\\[-11rem\\]{
    top: -11rem;
  }
  .sm\\:h-\\[11rem\\]{
    height: 11rem;
  }
  .sm\\:h-\\[12\\.5rem\\]{
    height: 12.5rem;
  }
  .sm\\:h-\\[12rem\\]{
    height: 12rem;
  }
  .sm\\:h-\\[2rem\\]{
    height: 2rem;
  }
  .sm\\:h-\\[300px\\]{
    height: 300px;
  }
  .sm\\:h-\\[7rem\\]{
    height: 7rem;
  }
  .sm\\:w-\\[400px\\]{
    width: 400px;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:flex-1{
    flex: 1 1;
  }
  .sm\\:rounded-\\[1\\.25rem\\]{
    border-radius: 1.25rem;
  }
  .sm\\:px-\\[2\\.5rem\\]{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:py-\\[0\\.65rem\\]{
    padding-top: 0.65rem;
    padding-bottom: 0.65rem;
  }
  .sm\\:py-\\[0\\.75rem\\]{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:pr-\\[1rem\\]{
    padding-right: 1rem;
  }
  .sm\\:text-\\[0\\.875rem\\]{
    font-size: 0.875rem;
  }
  .sm\\:text-\\[1\\.1rem\\]{
    font-size: 1.1rem;
  }
  .sm\\:text-\\[1\\.4rem\\]{
    font-size: 1.4rem;
  }
  .sm\\:text-\\[1\\.5rem\\]{
    font-size: 1.5rem;
  }
  .sm\\:text-\\[1rem\\]{
    font-size: 1rem;
  }
}
@media (min-width: 768px){
  .md\\:top-\\[-13\\.5rem\\]{
    top: -13.5rem;
  }
  .md\\:top-\\[-15\\.78rem\\]{
    top: -15.78rem;
  }
  .md\\:h-\\[15rem\\]{
    height: 15rem;
  }
  .md\\:h-\\[17\\.5rem\\]{
    height: 17.5rem;
  }
  .md\\:h-\\[2\\.5rem\\]{
    height: 2.5rem;
  }
  .md\\:h-\\[400px\\]{
    height: 400px;
  }
  .md\\:w-\\[600px\\]{
    width: 600px;
  }
  .md\\:text-\\[1rem\\]{
    font-size: 1rem;
  }
}
@media (min-width: 920px){
  .mmd\\:top-\\[-16\\.78rem\\]{
    top: -16.78rem;
  }
  .mmd\\:top-\\[-18rem\\]{
    top: -18rem;
  }
  .mmd\\:h-\\[19\\.5rem\\]{
    height: 19.5rem;
  }
  .mmd\\:h-\\[20rem\\]{
    height: 20rem;
  }
}
@media (min-width: 1024px){
  .lg\\:absolute{
    position: absolute;
  }
  .lg\\:bottom-\\[140px\\]{
    bottom: 140px;
  }
  .lg\\:bottom-\\[20\\%\\]{
    bottom: 20%;
  }
  .lg\\:left-\\[20\\%\\]{
    left: 20%;
  }
  .lg\\:top-\\[-0\\.5rem\\]{
    top: -0.5rem;
  }
  .lg\\:top-\\[-17\\.7rem\\]{
    top: -17.7rem;
  }
  .lg\\:top-\\[-24rem\\]{
    top: -24rem;
  }
  .lg\\:top-\\[6\\.5rem\\]{
    top: 6.5rem;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-\\[140px\\]{
    height: 140px;
  }
  .lg\\:h-\\[14rem\\]{
    height: 14rem;
  }
  .lg\\:h-\\[3rem\\]{
    height: 3rem;
  }
  .lg\\:h-\\[8\\.68rem\\]{
    height: 8.68rem;
  }
  .lg\\:w-auto{
    width: auto;
  }
  .lg\\:max-w-\\[80\\%\\]{
    max-width: 80%;
  }
  .lg\\:gap-0{
    gap: 0px;
  }
  .lg\\:gap-\\[1\\.5rem\\]{
    gap: 1.5rem;
  }
  .lg\\:self-start{
    align-self: flex-start;
  }
  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:px-\\[2\\.5rem\\]{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .lg\\:px-\\[2rem\\]{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:px-\\[6rem\\]{
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .lg\\:py-\\[5rem\\]{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .lg\\:pl-\\[4rem\\]{
    padding-left: 4rem;
  }
  .lg\\:pt-\\[3\\.5rem\\]{
    padding-top: 3.5rem;
  }
  .lg\\:text-\\[1\\.5rem\\]{
    font-size: 1.5rem;
  }
  .lg\\:text-\\[1\\.65rem\\]{
    font-size: 1.65rem;
  }
  .lg\\:text-\\[2\\.5rem\\]{
    font-size: 2.5rem;
  }
}
@media (min-width: 1208px){
  .xl\\:top-\\[-1rem\\]{
    top: -1rem;
  }
  .xl\\:top-\\[-24\\.2rem\\]{
    top: -24.2rem;
  }
  .xl\\:block{
    display: block;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:h-\\[20rem\\]{
    height: 20rem;
  }
  .xl\\:h-\\[27rem\\]{
    height: 27rem;
  }
  .xl\\:h-\\[28rem\\]{
    height: 28rem;
  }
  .xl\\:h-\\[4\\.5rem\\]{
    height: 4.5rem;
  }
  .xl\\:h-\\[9rem\\]{
    height: 9rem;
  }
  .xl\\:p-\\[0\\.5rem\\]{
    padding: 0.5rem;
  }
  .xl\\:py-\\[0\\.5rem\\]{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .xl\\:text-\\[4rem\\]{
    font-size: 4rem;
  }
}
@media (min-width: 1538px){
  .\\32xl\\:h-\\[27rem\\]{
    height: 27rem;
  }
}
@media (min-width: 1800px){
  .\\33xl\\:bottom-\\[180px\\]{
    bottom: 180px;
  }
  .\\33xl\\:top-\\[-26rem\\]{
    top: -26rem;
  }
  .\\33xl\\:h-\\[180px\\]{
    height: 180px;
  }
  .\\33xl\\:h-\\[30rem\\]{
    height: 30rem;
  }
  .\\33xl\\:h-\\[35rem\\]{
    height: 35rem;
  }
}
@media (min-width: 2000px){
  .\\34xl\\:top-\\[0\\.8rem\\]{
    top: 0.8rem;
  }
}
@media (min-width: 2500px){
  .\\35xl\\:bottom-\\[200px\\]{
    bottom: 200px;
  }
  .\\35xl\\:bottom-\\[30\\%\\]{
    bottom: 30%;
  }
  .\\35xl\\:top-\\[-29rem\\]{
    top: -29rem;
  }
  .\\35xl\\:top-\\[-30rem\\]{
    top: -30rem;
  }
  .\\35xl\\:h-\\[200px\\]{
    height: 200px;
  }
  .\\35xl\\:h-\\[34rem\\]{
    height: 34rem;
  }
  .\\35xl\\:h-\\[40rem\\]{
    height: 40rem;
  }
}
@media (min-width: 2800px){
  .\\36xl\\:bottom-\\[250px\\]{
    bottom: 250px;
  }
  .\\36xl\\:h-\\[250px\\]{
    height: 250px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;;EAEnB,yBAAyB;AAC3B;;;AAGA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,WAAW;;EAEX,gBAAgB;EAChB,GAAG;AACL;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAlDnB;EAAA;AAoDA;AApDA;EAAA,oBAoDA;EApDA;AAoDA;AApDA;EAAA,iBAoDA;EApDA,iBAoDA;EApDA;AAoDA;AApDA;EAAA,gFAoDA;EApDA,oGAoDA;EApDA;AAoDA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA,oBAoDA;IApDA;EAoDA;EApDA;IAAA,oBAoDA;IApDA;EAoDA;EApDA;IAAA,oBAoDA;IApDA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA,iBAoDA;IApDA;EAoDA;EApDA;IAAA,oBAoDA;IApDA;EAoDA;EApDA;IAAA,kBAoDA;IApDA;EAoDA;EApDA;IAAA,kBAoDA;IApDA;EAoDA;EApDA;IAAA,iBAoDA;IApDA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA,mBAoDA;IApDA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA;AApDA;EAAA;IAAA;EAoDA;EApDA;IAAA;EAoDA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n*::-webkit-scrollbar {\n  height: 0;\n  width: 4px;\n}\n*::-webkit-scrollbar-track {\n  border-radius: 8px;\n}\n*::-webkit-scrollbar-thumb {\n  height: 7px;\n  border-radius: 30px;\n\n  background-color: #FF7E10;\n}\n\n\n*::-webkit-slider-thumb {\n  /* ... */\n  height: 6px;\n}\n*:hover::-webkit-scrollbar {\n  height: 6px;\n\n  background: #fff;\n  /**/\n}\n\n.popup-overlay {\n  background: rgba(0, 0, 0, 0.30);\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
